import { createContext, type Dispatch, useContext } from 'react';

import type { ReportFlowDocument } from '../components/ReportFlow/report-flow-types';
import type { ReportDocumentAction } from './report-document-reducer';
import type { ReportDocumentConfig } from './report-document-types';

type ReportDocumentContextValue = {
  document: ReportDocumentConfig;
  flow: ReportFlowDocument;
  dispatch: Dispatch<ReportDocumentAction>;
};

export const ReportDocumentContext =
  createContext<ReportDocumentContextValue | null>(null);

export const useOptionalReportDocument = () =>
  useContext(ReportDocumentContext);

export const useReportDocument = (): ReportDocumentContextValue => {
  const context = useOptionalReportDocument();
  if (!context) {
    throw new Error(
      'useReportDocument must be used within a ReportDocumentProvider'
    );
  }
  return context;
};
